import { render } from "./WorkModal.vue?vue&type=template&id=6317951a&scoped=true"
import script from "./WorkModal.vue?vue&type=script&lang=js"
export * from "./WorkModal.vue?vue&type=script&lang=js"

import "./WorkModal.vue?vue&type=style&index=0&id=6317951a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6317951a"

export default script